module.exports = {"511111002":"铜河街道","511111100":"沙湾镇","511111101":"嘉农镇","511111102":"太平镇","511111103":"福禄镇","511111104":"牛石镇","511111106":"葫芦镇","511111107":"踏水镇","511111108":"轸溪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511111.json
// module id = 2461
// module chunks = 0